<!--
Container for displaying the content returned from the support and wellbeing content API based on user selection
@author dgm11b
-->

<template>
    <div id="swContent">
        <div class="container sw-content p-3 light-blue-container" v-if="content.accordion && content.accordion.length">
            <div class="accordion" id="wellbeingUrgent">
                <template v-for="(accordionContent, index) in content.accordion">
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                            <button 
                                class="accordion-button collapsed" 
                                type="button"
                                data-bs-toggle="collapse"
                                :data-bs-target="`#wellbeingUrgent-collapse${index}`"
                                aria-expanded="false"
                                :aria-controls="`#wellbeingUrgent-collapse${index}`"
                            >
                            {{ accordionContent[0] }}
                            </button>
                        </h2>
                        <div :id="`wellbeingUrgent-collapse${index}`" class="accordion-collapse collapse" style="">
                            <div class="accordion-body" v-html="accordionContent[1]">
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <template v-for="(contentArr, index) in content.wellbeing_body" v-if="Object.keys(content).length">
            <div :class="['container sw-content', os]" @click="handleClick">
                <div v-html="contentArr"
                :class="[
                    'container sw-content',
                    'p-4',
                    index % 2 == 0 ? 'white-container' : 'blue-container'
                ]">
                </div>
            </div>
        </template>
    </div>
</template>


<script setup>

import {onMounted, ref} from 'vue';
import {useRouter} from 'vue-router';
import {useDeviceType} from '@/composables/DeviceCommon.js'
import axios from 'axios'

const router = useRouter()
const os = useDeviceType();
const content = ref({})

onMounted(
    async () => {
        //make call to API to get content
        await getContent()
        //Format accordian data
        if(content.value.accordion) {
            accordionContent()
        }
    }
)

/**
 * Call the API to get the content for each content type
 * Save content to variable under properties for each content type
 * 
 * @returns {void}
 */
async function getContent() {
    const contentTypes = ['accordion','wellbeing_body']
    //Loop through contentTypes and save responses
    for (const contentType of contentTypes) {
        await axios.get('/timetable/wellbeing/next/'+contentType)
            .then(response => {
                
                let contentArr = []
                //Push pageContent property to temp array
                for(const site of response.data.sites) {
                    contentArr.push(site.pageContent)
                }
                //Save temp array value under contentType property in content variable
                content.value[contentType] = contentArr
            }).catch(
                err => {
                    console.log(err)
                }
            )
    } 
}

/**
 * Split accordion content via pipe character to get the accordian button title and the content seperated.
 * 
 * @returns {void}
 */
function accordionContent() {
    //Split the content into Title and Body via pipe character
    content.value.accordion = content.value.accordion.map(
        (accordionItem)=> {
            return accordionItem.split("|") 
        }
    )
}

/**
 * Any links clicked, check if internal app link and route if so
 * 
 * @returns {void}
 */
function handleClick(evt) {
    if(evt.target.dataset.appLink) {
        evt.preventDefault();
        router.push(evt.target.dataset.appLink)
    }
}

</script>

<style>

/*Because using v-html to display the content the html inserted cannot use the scoped css
* So using and ID #swContent on container to fake scope it to this component
* Want to avoid changing any global css at this stage*/

#swContent,
#swContent .sw-content {
    padding:0px;
}

/* The global one has center alignment
Use this until changed */
#swContent h2 {
    text-align:left;
    font-size:20px;
}

#swContent .white-container h2 {
    color: var(--uog-dark-blue);
}


#swContent .blue-container p {
    color: #fff;
}

#swContent .phone-btn {
    display:inline-block;
    border-radius: 10px;
    background: var(--uog-blue-10);
    color: var(--uog-dark-blue);
    font-size: 20px;
    padding: 9px 16px;
}

#swContent .blue-container {
    background-color: var(--uog-dark-blue);
    color:#fff;
}

#swContent .light-blue-container {
    background-color: var(--uog-blue-10);
}

#swContent .blue-container .phone-btn {
    background: #fff;
}

#swContent .btn {
    font-size:20px;
    background-color: var(--uog-dark-blue);
    border: solid 1px var(--uog-dark-blue);
    padding: 9px 16px;
    color:#fff;
    margin:4px 0px;
    line-height:normal;
    transition: background-color 0.4s, color 0.4s, border-color 0.4s;
}

#swContent .btn:hover {
    background-color:#fff;
    border: solid 1px var(--uog-dark-blue);
    color: var(--uog-dark-blue);
}

#swContent .btn:focus-visible {
    outline: 3px solid #000;
}


#swContent .btn:active {
    background-color: var(--uog-dark-blue);
    color: #fff;
}

#swContent .blue-container  .btn {
    background-color:#fff;
    border: solid 1px #fff;
    color: var(--uog-dark-blue);
}

#swContent .blue-container  .btn:hover {
    background-color: var(--uog-dark-blue);
    border: solid 1px #fff;
    color:#fff;
}

#swContent .blue-container .btn:focus-visible {
    outline: 3px solid #fff;
}

#swContent .blue-container .btn:active {
    background-color: #fff;
    color: var(--uog-dark-blue);
}

#appStoreLogos {
    overflow:auto;
    max-width: 365px;
}

#appStoreLogos a {
    display: inline-block;
    width: 50%;
    background-repeat: no-repeat;
    background-size: auto 100%;
    height: 65px;
    float: left;
}

a#playStore {
    background-image: url('@/assets/google-play-badge.png')
}

a#appStore {
    background-image: url('@/assets/apple-app-store-badge.svg');
    max-height: 45px;
    margin-top: 10px;
}

/*Hide store links on specific devices*/
.iOS a#playStore,
.Macintosh a#playStore {
    display:none;
}

.Android a#appStore {
    display:none;
}

/* Google Play image has spacing built in so when hidden, add padding to App Store image */
.iOS a#appStore,
.Macintosh a#appStore {
    margin-bottom: 20px;
}

@media(max-width:420px){
    #appStoreLogos {
        overflow:hidden;
    }
    #appStoreLogos a {
        display:block;
        width:100%;
    }

    #appStoreLogos a#appStore {
        margin-left:10px
    }
}

#swContent ul li a {
    line-height: 44px;
    color: var(--uog-dark-blue);
}

#swContent ul li a:hover {
    text-decoration: none;
}

#swContent .accordion-item:not(:last-child) {
    margin-bottom: 10px;
}

/* Override bootstrap styling */
#swContent .accordion-item:first-of-type .accordion-button,
#swContent .accordion-item:last-of-type .accordion-button.collapsed {
    border-radius: 0px;
}

</style>